interface FooterLink {
    key: string;
    labelKey: string;
    href: string;
}

export const footerLinks: FooterLink[] = [
    { key: "company", labelKey: "company", href: "#" },
    { key: "apiIntegrations", labelKey: "apiIntegrations", href: "#" },
    { key: "privacyPolicy", labelKey: "privacyPolicy", href: "#" },
    { key: "termsConditions", labelKey: "termsConditions", href: "#" },
    { key: "news", labelKey: "news", href: "#" },
];
